import { useCallback, useMemo } from 'react'
import moment from 'moment'

type ExecuteJsContext = Record<string, unknown>

type ExecuteJsResult = {
  value: unknown
  error: string | undefined
}

export const useExecutePreviewJs = () => {
  const navigation = useMemo(
    () => ({
      navigate: (...args: unknown[]) =>
        console.warn('Preview navigation.navigate is not implemented', ...args),
      goBack: () => console.warn('Preview navigation.goBack is not implemented'),
      replace: (...args: unknown[]) =>
        console.warn('Preview navigation.replace is not implemented', ...args),
    }),
    []
  )

  const routeParams = useMemo(() => ({}), [])

  return useCallback(
    (code: string | undefined, context: ExecuteJsContext = {}): ExecuteJsResult => {
      const trimmed = (code || '').trim()

      if (!trimmed) {
        return { value: undefined, error: undefined }
      }

      const hasReturn = /return\b/.test(trimmed)
      const executable = hasReturn ? trimmed : `return (${trimmed});`

      try {
        const fullContext = {
          ...context,
          navigation,
          moment,
          routeParams,
          Math,
          Date,
        }
        const keys = Object.keys(fullContext)
        const fn = new Function(...keys, executable)
        const result = fn(...Object.values(fullContext))

        return { value: result, error: undefined }
      } catch (error) {
        const message = error instanceof Error ? error.message : String(error)
        console.error('Preview JS execution error', error)

        return { value: undefined, error: message }
      }
    },
    [navigation, routeParams]
  )
}
